import { type HotkeyLayer } from '@/ui/utilities/hotkey/types/HotkeyLayer';

export const removeFirstHotkeyLayer = (
  openHotkeyLayers: HotkeyLayer[],
  layerToRemove: HotkeyLayer,
): HotkeyLayer[] => {
  const layerIndex = openHotkeyLayers.indexOf(layerToRemove);

  return layerIndex === -1
    ? openHotkeyLayers
    : openHotkeyLayers.toSpliced(layerIndex, 1);
};
